import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Activity, Group, OnCallGroup, Pageable} from 'src/app/models';

@Injectable({
    providedIn: 'root'
})
export class GroupsService {
    url = '/api/v1/groups';

    constructor(public http: HttpClient) {
    }

    createGroup(newGroup: any): any {
        return this.http.post(this.url, newGroup);
    }

    updateGroup(request: Group): any {
        return this.http.put(this.url, request);
    }

    deleteGroup(id: number): any {
        return this.http.delete(`${this.url}/${id}`);
    }

    deleteGroupOwner(groupId: number, ownerId: string): any {
        return this.http.delete(`${this.url}/${groupId}/owners/${ownerId}`);
    }

    getGroupNames(val: string, activity?: Activity): Observable<Group[]> {
        val = encodeURIComponent(val);
        return this.http.get<Group[]>(`${this.url}?identifier=${val}${activity != undefined ? `&activity=${activity}` : ''}`)
            .pipe(map(groupsPage => groupsPage['content']));
    }

    getGroupNamesAndGroupTypeId(val: string, groupTypeId: string, activity?: Activity): Observable<Group[]> {
        val = encodeURIComponent(val);
        return this.http.get<Group[]>(`${this.url}?identifier=${val}&groupTypeId=${groupTypeId}${activity != undefined? `&activity=${activity}` : ''}`)
            .pipe(map(groupsPage => groupsPage['content']));
    }

    getAllGroupNames(val: string, activity: Activity): Observable<Group[]> {
        val = encodeURIComponent(val);
        return this.http.get<Group[]>(`${this.url}?identifier=${val}&activity=${activity}`)
            .pipe(map(groupsPage => groupsPage['content']));
    }

    getGroupNamesPage(val: string, page: number, activity?: Activity): Observable<Pageable<Group>> {
        val = encodeURIComponent(val);
        return this.http.get<Pageable<Group>>(`${this.url}?identifier=${val}${activity != undefined ? `&activity=${activity}` : ''}&size=${page}`);
    }

    getGroupNamesPageAndGroupTypeId(val: string, page: number, groupTypeId: string, activity?: Activity): Observable<Pageable<Group>> {
        val = encodeURIComponent(val);
        let activityString = activity != undefined ? `&activity=${activity}` : '';
        return this.http.get<Pageable<Group>>(`${this.url}?identifier=${val}&groupTypeId=${groupTypeId}${activityString}&size=${page}`);
    }

    getGroup(id: number): Observable<Group> {
        return this.http.get<Group>(`${this.url}/${id}`);
    }

    getAllGroupsPage(page): Observable<Pageable<Group>> {
        return this.http.get<Pageable<Group>>(`${this.url}??&size=${page.limit}&page=${page.offset}&sort=${page.orderBy},${page.orderDir}`);
    }

    getGroupsByMemberID(id: number): any {
        return this.http.get(`${this.url}/member/${id}`)
            .pipe(map(groups => groups['content']));
    }

    addGroupMember(groupId, individualId, replace) {
        return this.http.put(`${this.url}/${groupId}/individual/${individualId}?replace=${replace}`, null);
    }

    removeGroupMember(groupId: number, memberId: string): any {
        return this.http.delete(`${this.url}/${groupId}/member/${memberId}`);
    }

    getGroupOwners(groupId: number): any {
        return this.http.get(`${this.url}/${groupId}/owners`);
    }

    isGroupMember(groupId: number, memberId: string, memberType: string, checkSubGroups: boolean): any {
        return this.http.get(`${this.url}/${groupId}/member/${memberId}?memberType=${memberType}&checkSubGroups=${checkSubGroups}`);
    }

    getMembership(groupId: number): any {
        if (groupId != null) {
            return this.http.get(`${this.url}/membership/${groupId}`);
        }
    }

    getGroupsByOwnerIdPage(identifier: number, page, activity): any {
        return this.http.get<Pageable<Group>>(`${this.url}/owner/${identifier}??&size=${page.limit}&page=${page.offset}&sort=${page.orderBy},${page.orderDir}&activity=${activity}`);
    }

    getOnCalls(groupId: string): Observable<OnCallGroup> {
        return this.http.get<OnCallGroup>(`${this.url}/on-calls?identifier=${groupId}`);
    }
}
